// Generated by Avo VERSION 53.2.0, PLEASE EDIT WITH CARE
/* eslint-disable */

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  self.DOMException = self.DOMException;
  try {
    new self.DOMException();
  } catch (err) {
    self.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    self.DOMException.prototype = Object.create(Error.prototype);
    self.DOMException.prototype.constructor = self.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new self.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new self.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }
})();

(function(exports) {
  var __AVO_DEV__ = false;
  var __AVO_ENV__ = null;
  var __REPORT_FAILURE_AS__ = null;
  var __STRICT__ = null;

  var __WEB_DEBUGGER__ = true;

  // polyfill Array.isArray
  if (!Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  }

  // polyfill Object.assign
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  if (!Object.keys) {
    Object.keys = (function() {
      'use strict';
      var hasOwnProperty = Object.prototype.hasOwnProperty,
          hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
          dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
          ],
          dontEnumsLength = dontEnums.length;

      return function(obj) {
        if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }

        var result = [], prop, i;

        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }());
  }

  // polyfill Array.indexOf
  if (!Array.prototype.indexOf)  Array.prototype.indexOf = (function(Object, max, min){
    "use strict";
    return function indexOf(member, fromIndex) {
      if(this===null||this===undefined)throw TypeError("Array.prototype.indexOf called on null or undefined");

      var that = Object(this), Len = that.length >>> 0, i = min(fromIndex | 0, Len);
      if (i < 0) i = max(0, Len+i); else if (i >= Len) return -1;

      if(member===void 0){ for(; i !== Len; ++i) if(that[i]===void 0 && i in that) return i; // undefined
      }else if(member !== member){   for(; i !== Len; ++i) if(that[i] !== that[i]) return i; // NaN
      }else                           for(; i !== Len; ++i) if(that[i] === member) return i; // all else

      return -1; // if the value was not found, then return -1
    };
  })(Object, Math.max, Math.min);

  var array_difference, AvoAssert, AvoLogger;
  array_difference = function array_difference(a1, a2) {
    var result = [];
    for (var i = 0; i < a1.length; i++) {
      if (a2.indexOf(a1[i]) === -1) {
        result.push(a1[i]);
      }
    }
    return result;
  }

  AvoAssert = {
    assertObject: function assertObject(propertyId, propName, obj) {
      if (typeof obj !== 'object') {
        var message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
        return [{tag: 'expectedObjectType', propertyId: propertyId, message: message, actualType: typeof obj}];
      } else {
        return [];
      }
    },

    assertString: function assertString(propertyId, propName, str) {
      if (typeof str !== 'string') {
        var message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
        return [{tag: 'expectedStringType', propertyId: propertyId, message: message, actualType: typeof str}];
      } else {
        return [];
      }
    },

    assertInt: function assertInt(propertyId, propName, int) {
      if (typeof int === 'number' && int !== Math.round(int)) {
        var message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof int !== 'number') {
        var message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, message: message, actualType: typeof int}];
      } else {
        return [];
      }
    },

    assertLong: function assertLong(propertyId, propName, long) {
      if (typeof long === 'number' && long !== Math.round(long)) {
        var message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof long !== 'number') {
        var message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, message: message, actualType: typeof long}];
      } else {
        return [];
      }
    },

    assertFloat: function assertFloat(propertyId, propName, float) {
      if (typeof float !== 'number') {
        var message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
        return [{tag: 'expectedFloatType', propertyId: propertyId, message: message, actualType: typeof float}];
      } else {
        return [];
      }
    },

    assertBool: function assertBool(propertyId, propName, bool) {
      if (typeof bool !== 'boolean') {
        var message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
        return [{tag: 'expectedBoolType', propertyId: propertyId, message: message, actualType: typeof bool}];
      } else {
        return [];
      }
    },

    assertMax: function assertMax(propertyId, propName, max, value) {
      if (value > max) {
        var message = propName +
          ' has a maximum value of ' +
          max +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMax', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertMin: function assertMin(propertyId, propName, min, value) {
      if (value < min) {
        var message = propName +
          ' has a minimum value of ' +
          min +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMin', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertList: function assertList(propertyId, propName, value) {
      if (!Array.isArray(value)) {
        var message = propName + ' should be of type list but you provided type ' + typeof value;
        return [{tag: 'expectedList', propertyId: propertyId, message: message, actualType: typeof value}];
      } else {
        return [];
      }
    },

    assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    },

    assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    }
  };

  AvoLogger = {
    logEventSent: function logEventSent(eventName, eventProperties, userProperties) {
      console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
    }
    };

  var _avo_invoke, _avo_invoke_meta;
var _avo_sampling_rate = 1.0;
function _avo_invoke_payload(body) {
  if (typeof window === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      }).then(function(res) { return res.json(); }).then(function(data) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
  _avo_invoke_payload({
    "ac": "2yRLCMNsP73YfY1M6LcB",
    "br": "master",
    "en": env,
    "ev": eventId,
    "ha": hash,
    "sc": "vwFXzvEVl7YL9ZHhbVJY",
    "se": (new Date()).toISOString(),
    "so": "5_qZ4zTyK",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}

_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
  _avo_invoke_payload({
    "ac": "2yRLCMNsP73YfY1M6LcB",
    "br": "master",
    "en": env,
    "ty": type,
    "sc": "vwFXzvEVl7YL9ZHhbVJY",
    "se": (new Date()).toISOString(),
    "so": "5_qZ4zTyK",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}


  var _avo_debugger_log;
var _avo_debugger_events_during_boot = [];
var _avo_debugger_ready = false;

if (typeof window !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    var iframe = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      var message = {
        type_: "avo-debugger-boot-events",
        schemaId: "vwFXzvEVl7YL9ZHhbVJY",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId, eventName, messages, eventProperties, userProperties) {
  if (typeof window === 'undefined') { return; }
  var event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties: eventProperties,
    userProperties: userProperties
  };

  if (_avo_debugger_ready) {
    var message = {type_: "avo-debugger-events", events: [event]};
    document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}


  function assertOptionalQuizSearchPosition(quizSearchPosition, label_) {
    var messages = [];
    if (quizSearchPosition !== undefined && quizSearchPosition !== null) {
      messages = messages.concat(AvoAssert.assertInt("1QCQCkw4Ph", label_ ? 'quiz_search_position' + ': ' + label_ : 'quiz_search_position', quizSearchPosition));
    }
    return messages;
  }

  function assertCourseId(courseId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("5vn6k8qMwf", label_ ? 'course_id' + ': ' + label_ : 'course_id', courseId));
    return messages;
  }

  function assertOptionalCourseQueryId(courseQueryId, label_) {
    var messages = [];
    if (courseQueryId !== undefined && courseQueryId !== null) {
      messages = messages.concat(AvoAssert.assertString("6e-cDrq3PM", label_ ? 'course_query_id' + ': ' + label_ : 'course_query_id', courseQueryId));
    }
    return messages;
  }

  function assertHits(hits, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("7_QxEWZea-", label_ ? 'hits' + ': ' + label_ : 'hits', hits));
    return messages;
  }

  function assertFilters(filters, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BndLouvVWt", label_ ? 'filters' + ': ' + label_ : 'filters', filters));
    return messages;
  }

  function assertQuery(query, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("CYWqMDO7TU", label_ ? 'query' + ': ' + label_ : 'query', query));
    return messages;
  }

  function assertOptionalSearchResultType(searchResultType, label_) {
    var messages = [];
    if (searchResultType !== undefined && searchResultType !== null) {
      messages = messages.concat(AvoAssert.assertString("H3iRyDVVUt", label_ ? 'search_result_type' + ': ' + label_ : 'search_result_type', searchResultType));
    }
    return messages;
  }

  function assertOptionalQuizId(quizId, label_) {
    var messages = [];
    if (quizId !== undefined && quizId !== null) {
      messages = messages.concat(AvoAssert.assertInt("H9MrZZ7TKo", label_ ? 'quiz_id' + ': ' + label_ : 'quiz_id', quizId));
    }
    return messages;
  }

  function assertAction(action, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Ig_YDgwAeo", label_ ? 'action' + ': ' + label_ : 'action', action));
    return messages;
  }

  function assertPath(path, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Ougio4Hgqc", label_ ? 'path' + ': ' + label_ : 'path', path));
    return messages;
  }

  function assertOptionalQuizQueryId(quizQueryId, label_) {
    var messages = [];
    if (quizQueryId !== undefined && quizQueryId !== null) {
      messages = messages.concat(AvoAssert.assertString("PaQ7fmmaJc", label_ ? 'quiz_query_id' + ': ' + label_ : 'quiz_query_id', quizQueryId));
    }
    return messages;
  }

  function assertQueryId(queryId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("R2oAa95CDZ", label_ ? 'query_id' + ': ' + label_ : 'query_id', queryId));
    return messages;
  }

  function assertOptionalIsCourseSearch(isCourseSearch, label_) {
    var messages = [];
    if (isCourseSearch !== undefined && isCourseSearch !== null) {
      messages = messages.concat(AvoAssert.assertBool("RKjFsLS2I9", label_ ? 'is_course_search' + ': ' + label_ : 'is_course_search', isCourseSearch));
    }
    return messages;
  }

  function assertOptionalCustomSearchCardType(customSearchCardType, label_) {
    var messages = [];
    if (customSearchCardType !== undefined && customSearchCardType !== null) {
      messages = messages.concat(AvoAssert.assertString("T0lyCWVfDN", label_ ? 'custom_search_card_type' + ': ' + label_ : 'custom_search_card_type', customSearchCardType));
    }
    return messages;
  }

  function assertSearchType(searchType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ZZHdQbQnrh", label_ ? 'search_type' + ': ' + label_ : 'search_type', searchType));
    return messages;
  }

  function assertPage(page, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_EoHIjL2Uw", label_ ? 'page' + ': ' + label_ : 'page', page));
    return messages;
  }

  function assertOptionalFromSuggestedSearch(fromSuggestedSearch, label_) {
    var messages = [];
    if (fromSuggestedSearch !== undefined && fromSuggestedSearch !== null) {
      messages = messages.concat(AvoAssert.assertBool("haZfTd8G3u", label_ ? 'from_suggested_search' + ': ' + label_ : 'from_suggested_search', fromSuggestedSearch));
    }
    return messages;
  }

  function assertOptionalCourseSearchGroupQueryId(courseSearchGroupQueryId,
    label_) {
    var messages = [];
    if (courseSearchGroupQueryId !== undefined && courseSearchGroupQueryId !== null) {
      messages = messages.concat(AvoAssert.assertString("jLr2ENtGk7", label_ ? 'course_search_group_query_id' + ': ' + label_ : 'course_search_group_query_id', courseSearchGroupQueryId));
    }
    return messages;
  }

  function assertIsAndroid(isAndroid, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("oWTfBx2nOY", label_ ? 'is_android' + ': ' + label_ : 'is_android', isAndroid));
    return messages;
  }

  function assertPages(pages, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("tCe7MdWHMi", label_ ? 'pages' + ': ' + label_ : 'pages', pages));
    return messages;
  }

  function assertCourseSearchPosition(courseSearchPosition, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("zRASu4V1KP", label_ ? 'course_search_position' + ': ' + label_ : 'course_search_position', courseSearchPosition));
    return messages;
  }


  var CurrentTrackingInterop;
  function setup_(options, systemProperties,
    CurrentTrackingInteropDestination, destinationOptions) {
    __WEB_DEBUGGER__ = false;
    if (options.validateProperties === true) {
      __AVO_DEV__ = true;
    }

    destinationOptions = destinationOptions || {};

    if (options.useProductionKey) {
    } else {
    }

    CurrentTrackingInterop = CurrentTrackingInteropDestination;
    CurrentTrackingInterop.make(options.useProductionKey);
    if (__AVO_DEV__) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'setup', [], 'setup');
    }
  }

  function initAvo(options, systemProperties, destinationOptions,
    CurrentTrackingInteropDestination) {
    if (__AVO_ENV__ !== null) {
      return;
    }
    __AVO_ENV__ = options.env.toLowerCase();
    if (options.strict !== undefined) {
      __STRICT__ = options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
      __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ = (typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== 'prod');
    if (__AVO_ENV__ !== 'prod') {
      __AVO_DEV__ = true;
    }

    destinationOptions = destinationOptions || {};

    if (__WEB_DEBUGGER__) {
(function() {
  if (typeof window === 'undefined') { return; }
  var init = function() {
    if (document.getElementById("avo-debugger") === null) {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      iframe.id = "avo-debugger";
      iframe.src = "https://www.avo.app/_debugger";
      iframe.style = "display: none;";
    }
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

    }
    if (__AVO_ENV__ === 'prod') {
    }
    if (__AVO_ENV__ === 'dev') {
    }

    CurrentTrackingInterop = CurrentTrackingInteropDestination;
    CurrentTrackingInterop.make(__AVO_ENV__);
    if (__AVO_DEV__) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }

  /**
   * search_result: Existing search_result event
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.searchType - no description
   * @param {string} properties.query - no description
   * @param {string} properties.filters - no description
   * @param {int} properties.page - no description
   * @param {int} properties.pages - no description
   * @param {string} properties.path - Path the user is searching from
   * @param {bool} properties.isAndroid - no description
   * @param {string} properties.customSearchCardType - Special, course, or chapter; only if the search result
   * @param {string} properties.searchResultType - search_group, no_result, courses_and_quizzes, courses, quizzes
   * @param {bool} properties.isCourseSearch - no description
   * @param {bool} properties.fromSuggestedSearch - Only when is_course_search = true; if the query came from a suggested search
   * @param {string} properties.courseQueryId - To track conversions
   * @param {int} properties.hits - no description
   * @param {string} properties.quizQueryId - no description
   * @param {string} properties.courseSearchGroupQueryId - no description
   *
   * @see {@link https://www.avo.app/schemas/vwFXzvEVl7YL9ZHhbVJY/events/ScWrQ9ytR}
   */
  function searchResult(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSearchType(properties.searchType));
      messages = messages.concat(assertQuery(properties.query));
      messages = messages.concat(assertFilters(properties.filters));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPages(properties.pages));
      messages = messages.concat(assertPath(properties.path));
      messages = messages.concat(assertIsAndroid(properties.isAndroid));
      messages = messages.concat(assertOptionalCustomSearchCardType(properties.customSearchCardType));
      messages = messages.concat(assertOptionalSearchResultType(properties.searchResultType));
      messages = messages.concat(assertOptionalIsCourseSearch(properties.isCourseSearch));
      messages = messages.concat(assertOptionalFromSuggestedSearch(properties.fromSuggestedSearch));
      messages = messages.concat(assertOptionalCourseQueryId(properties.courseQueryId));
      messages = messages.concat(assertHits(properties.hits));
      messages = messages.concat(assertOptionalQuizQueryId(properties.quizQueryId));
      messages = messages.concat(assertOptionalCourseSearchGroupQueryId(properties.courseSearchGroupQueryId));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("search_result", Object.keys(properties), [
        "searchType",
        "query",
        "filters",
        "page",
        "pages",
        "path",
        "isAndroid",
        "customSearchCardType",
        "searchResultType",
        "isCourseSearch",
        "fromSuggestedSearch",
        "courseQueryId",
        "hits",
        "quizQueryId",
        "courseSearchGroupQueryId"
      ]));
      // debug console in Avo
      _avo_invoke(__AVO_ENV__, "ScWrQ9ytR", "597246c746d6092b6f5bc0a6d1c5f0affb91b93c6fb784ecb05cff2456959a5a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');

      AvoLogger.logEventSent("search_result", {
        "search_type": properties.searchType,
        "query": properties.query,
        "filters": properties.filters,
        "page": properties.page,
        "pages": properties.pages,
        "path": properties.path,
        "is_android": properties.isAndroid,
        "custom_search_card_type": properties.customSearchCardType,
        "search_result_type": properties.searchResultType,
        "is_course_search": properties.isCourseSearch,
        "from_suggested_search": properties.fromSuggestedSearch,
        "course_query_id": properties.courseQueryId,
        "hits": properties.hits,
        "quiz_query_id": properties.quizQueryId,
        "course_search_group_query_id": properties.courseSearchGroupQueryId,
        }, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ScWrQ9ytR", "search_result", messages, [
        {id: "6e-cDrq3PM", name: "course_query_id", value: properties.courseQueryId},
        {id: "7_QxEWZea-", name: "hits", value: properties.hits},
        {id: "BndLouvVWt", name: "filters", value: properties.filters},
        {id: "CYWqMDO7TU", name: "query", value: properties.query},
        {id: "H3iRyDVVUt", name: "search_result_type", value: properties.searchResultType},
        {id: "Ougio4Hgqc", name: "path", value: properties.path},
        {id: "PaQ7fmmaJc", name: "quiz_query_id", value: properties.quizQueryId},
        {id: "RKjFsLS2I9", name: "is_course_search", value: properties.isCourseSearch},
        {id: "T0lyCWVfDN", name: "custom_search_card_type", value: properties.customSearchCardType},
        {id: "ZZHdQbQnrh", name: "search_type", value: properties.searchType},
        {id: "_EoHIjL2Uw", name: "page", value: properties.page},
        {id: "haZfTd8G3u", name: "from_suggested_search", value: properties.fromSuggestedSearch},
        {id: "jLr2ENtGk7", name: "course_search_group_query_id", value: properties.courseSearchGroupQueryId},
        {id: "oWTfBx2nOY", name: "is_android", value: properties.isAndroid},
        {id: "tCe7MdWHMi", name: "pages", value: properties.pages},
        ], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'search_result': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    // destination CurrentTrackingInterop
    CurrentTrackingInterop.logEvent("search_result", {
    "search_type": properties.searchType,
    "query": properties.query,
    "filters": properties.filters,
    "page": properties.page,
    "pages": properties.pages,
    "path": properties.path,
    "is_android": properties.isAndroid,
    "custom_search_card_type": properties.customSearchCardType,
    "search_result_type": properties.searchResultType,
    "is_course_search": properties.isCourseSearch,
    "from_suggested_search": properties.fromSuggestedSearch,
    "course_query_id": properties.courseQueryId,
    "hits": properties.hits,
    "quiz_query_id": properties.quizQueryId,
    "course_search_group_query_id": properties.courseSearchGroupQueryId,
    });
  }

  /**
   * course_search_event: Click and conversion actions a user takes after clicking on a course search result.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.action - clicked_course_card, clicked_quiz_card, started_quiz, finished_quiz
   * @param {int} properties.courseId - The course ID from the quiz or course the user clicked, or the course ID from the quiz the user started or finished.
   * @param {int} properties.quizId - The quiz ID from the quiz the user clicked, or the quiz the user started or finished.
   * @param {int} properties.courseSearchPosition - Tracks the position of the course the user clicked on (starting with 1 on the left —> right —> down left —> down right)
   * @param {int} properties.quizSearchPosition - Tracks the position of the quiz the user clicked on.
   * @param {string} properties.query - no description
   * @param {string} properties.queryId - Either the course, course search group, or quiz query ID from search_result.
   *
   * @see {@link https://www.avo.app/schemas/vwFXzvEVl7YL9ZHhbVJY/events/Fhafx5S6kK}
   */
  function courseSearchEvent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertAction(properties.action));
      messages = messages.concat(assertCourseId(properties.courseId));
      messages = messages.concat(assertOptionalQuizId(properties.quizId));
      messages = messages.concat(assertCourseSearchPosition(properties.courseSearchPosition));
      messages = messages.concat(assertOptionalQuizSearchPosition(properties.quizSearchPosition));
      messages = messages.concat(assertQuery(properties.query));
      messages = messages.concat(assertQueryId(properties.queryId));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("course_search_event", Object.keys(properties), [
        "action",
        "courseId",
        "quizId",
        "courseSearchPosition",
        "quizSearchPosition",
        "query",
        "queryId"
      ]));
      // debug console in Avo
      _avo_invoke(__AVO_ENV__, "Fhafx5S6kK", "24c7598ad9ca0ca13cb7eb7def75a55c70f64fdc3b67bf3c80bf636335d8103c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');

      AvoLogger.logEventSent("course_search_event", {
        "action": properties.action,
        "course_id": properties.courseId,
        "quiz_id": properties.quizId,
        "course_search_position": properties.courseSearchPosition,
        "quiz_search_position": properties.quizSearchPosition,
        "query": properties.query,
        "query_id": properties.queryId,
        }, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Fhafx5S6kK", "course_search_event", messages, [
        {id: "1QCQCkw4Ph", name: "quiz_search_position", value: properties.quizSearchPosition},
        {id: "5vn6k8qMwf", name: "course_id", value: properties.courseId},
        {id: "CYWqMDO7TU", name: "query", value: properties.query},
        {id: "H9MrZZ7TKo", name: "quiz_id", value: properties.quizId},
        {id: "Ig_YDgwAeo", name: "action", value: properties.action},
        {id: "R2oAa95CDZ", name: "query_id", value: properties.queryId},
        {id: "zRASu4V1KP", name: "course_search_position", value: properties.courseSearchPosition},
        ], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'course_search_event': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    // destination CurrentTrackingInterop
    CurrentTrackingInterop.logEvent("course_search_event", {
    "action": properties.action,
    "course_id": properties.courseId,
    "quiz_id": properties.quizId,
    "course_search_position": properties.courseSearchPosition,
    "quiz_search_position": properties.quizSearchPosition,
    "query": properties.query,
    "query_id": properties.queryId,
    });
  }

  function validateAvoEvent(options) {
    var __STRICT__ = null;
    var __WEB_DEBUGGER__ = null;
    var __REPORT_FAILURE_AS__ = null;
    var __AVO_ENV_VFN__ = typeof __AVO_ENV__ !== 'undefined' && __AVO_ENV__ !== null ? __AVO_ENV__ : options.env;
    __WEB_DEBUGGER__ = (typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV_VFN__ !== 'prod');
    if (__WEB_DEBUGGER__) {
(function() {
  if (typeof window === 'undefined') { return; }
  var init = function() {
    if (document.getElementById("avo-debugger") === null) {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      iframe.id = "avo-debugger";
      iframe.src = "https://www.avo.app/_debugger";
      iframe.style = "display: none;";
    }
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

    }
    if (options.strict !== undefined) {
      __STRICT__ = options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
      __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    var eventName = options.eventName;
    var eventProperties = options.eventProperties || options.properties || {};
    var userProperties = options.userProperties || {};
    var messages = [];
    switch (eventName) {
      case "search_result":
        messages = messages.concat(assertSearchType(eventProperties["search_type"]));
        messages = messages.concat(assertQuery(eventProperties["query"]));
        messages = messages.concat(assertFilters(eventProperties["filters"]));
        messages = messages.concat(assertPage(eventProperties["page"]));
        messages = messages.concat(assertPages(eventProperties["pages"]));
        messages = messages.concat(assertPath(eventProperties["path"]));
        messages = messages.concat(assertIsAndroid(eventProperties["is_android"]));
        messages = messages.concat(assertOptionalCustomSearchCardType(eventProperties["custom_search_card_type"]));
        messages = messages.concat(assertOptionalSearchResultType(eventProperties["search_result_type"]));
        messages = messages.concat(assertOptionalIsCourseSearch(eventProperties["is_course_search"]));
        messages = messages.concat(assertOptionalFromSuggestedSearch(eventProperties["from_suggested_search"]));
        messages = messages.concat(assertOptionalCourseQueryId(eventProperties["course_query_id"]));
        messages = messages.concat(assertHits(eventProperties["hits"]));
        messages = messages.concat(assertOptionalQuizQueryId(eventProperties["quiz_query_id"]));
        messages = messages.concat(assertOptionalCourseSearchGroupQueryId(eventProperties["course_search_group_query_id"]));
        messages = messages.concat(AvoAssert.assertNoAdditionalProperties("search_result", Object.keys(eventProperties), [
          "search_type",
          "query",
          "filters",
          "page",
          "pages",
          "path",
          "is_android",
          "custom_search_card_type",
          "search_result_type",
          "is_course_search",
          "from_suggested_search",
          "course_query_id",
          "hits",
          "quiz_query_id",
          "course_search_group_query_id"
        ]));

        // debug console in Avo
        _avo_invoke(__AVO_ENV_VFN__, "ScWrQ9ytR", "597246c746d6092b6f5bc0a6d1c5f0affb91b93c6fb784ecb05cff2456959a5a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'validate');

        if (__WEB_DEBUGGER__) {
          // Avo web debugger
          _avo_debugger_log("ScWrQ9ytR", "search_result", messages, [
          {id: "search_type", name: "search_type", value: eventProperties["search_type"]},
          {id: "query", name: "query", value: eventProperties["query"]},
          {id: "filters", name: "filters", value: eventProperties["filters"]},
          {id: "page", name: "page", value: eventProperties["page"]},
          {id: "pages", name: "pages", value: eventProperties["pages"]},
          {id: "path", name: "path", value: eventProperties["path"]},
          {id: "is_android", name: "is_android", value: eventProperties["is_android"]},
          {id: "custom_search_card_type", name: "custom_search_card_type", value: eventProperties["custom_search_card_type"]},
          {id: "search_result_type", name: "search_result_type", value: eventProperties["search_result_type"]},
          {id: "is_course_search", name: "is_course_search", value: eventProperties["is_course_search"]},
          {id: "from_suggested_search", name: "from_suggested_search", value: eventProperties["from_suggested_search"]},
          {id: "course_query_id", name: "course_query_id", value: eventProperties["course_query_id"]},
          {id: "hits", name: "hits", value: eventProperties["hits"]},
          {id: "quiz_query_id", name: "quiz_query_id", value: eventProperties["quiz_query_id"]},
          {id: "course_search_group_query_id", name: "course_search_group_query_id", value: eventProperties["course_search_group_query_id"]}], []);
        }
        if (__AVO_ENV_VFN__ !== 'prod' && (__STRICT__ === null || __STRICT__)) {
          // throw exception if messages is not empty
          if (messages.length !== 0) {
            throw new Error("Error sending event 'search_result': " + messages[0].message)
          }
        } else {
          messages.forEach(function(m) {
            console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
          });
        }
        break;
      case "course_search_event":
        messages = messages.concat(assertAction(eventProperties["action"]));
        messages = messages.concat(assertCourseId(eventProperties["course_id"]));
        messages = messages.concat(assertOptionalQuizId(eventProperties["quiz_id"]));
        messages = messages.concat(assertCourseSearchPosition(eventProperties["course_search_position"]));
        messages = messages.concat(assertOptionalQuizSearchPosition(eventProperties["quiz_search_position"]));
        messages = messages.concat(assertQuery(eventProperties["query"]));
        messages = messages.concat(assertQueryId(eventProperties["query_id"]));
        messages = messages.concat(AvoAssert.assertNoAdditionalProperties("course_search_event", Object.keys(eventProperties), [
          "action",
          "course_id",
          "quiz_id",
          "course_search_position",
          "quiz_search_position",
          "query",
          "query_id"
        ]));

        // debug console in Avo
        _avo_invoke(__AVO_ENV_VFN__, "Fhafx5S6kK", "24c7598ad9ca0ca13cb7eb7def75a55c70f64fdc3b67bf3c80bf636335d8103c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'validate');

        if (__WEB_DEBUGGER__) {
          // Avo web debugger
          _avo_debugger_log("Fhafx5S6kK", "course_search_event", messages, [
          {id: "action", name: "action", value: eventProperties["action"]},
          {id: "course_id", name: "course_id", value: eventProperties["course_id"]},
          {id: "quiz_id", name: "quiz_id", value: eventProperties["quiz_id"]},
          {id: "course_search_position", name: "course_search_position", value: eventProperties["course_search_position"]},
          {id: "quiz_search_position", name: "quiz_search_position", value: eventProperties["quiz_search_position"]},
          {id: "query", name: "query", value: eventProperties["query"]},
          {id: "query_id", name: "query_id", value: eventProperties["query_id"]}], []);
        }
        if (__AVO_ENV_VFN__ !== 'prod' && (__STRICT__ === null || __STRICT__)) {
          // throw exception if messages is not empty
          if (messages.length !== 0) {
            throw new Error("Error sending event 'course_search_event': " + messages[0].message)
          }
        } else {
          messages.forEach(function(m) {
            console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
          });
        }
        break;
      default:
        // debug console in Avo
        messages.push({tag: "unexpectedEvent", eventName: eventName, shape: Object.keys(eventProperties).map(function(key) { return [key, typeof eventProperties[key]]; }).reduce(function(prev,curr){prev[curr[0]]=curr[1];return prev;},{}), shapeUserProps: Object.keys(userProperties).map(function(key) { return [key, typeof userProperties[key]]; }).reduce(function(prev,curr){prev[curr[0]]=curr[1];return prev;},{})});
        _avo_invoke_meta(__AVO_ENV_VFN__, "unexpectedEvent", messages, "validate");

        if (__WEB_DEBUGGER__) {
          // Avo web debugger
          _avo_debugger_log(eventName, eventName, messages, Object.keys(eventProperties).map(function(key) { return {id: key, name: key, value: eventProperties[key]}; }), Object.keys(userProperties).map(function(key) { return {id: key, name: key, value: userProperties[key]}; }));
        }
    }
  }

  exports.validateAvoEvent = validateAvoEvent;
  exports.searchResult = searchResult;
  exports.courseSearchEvent = courseSearchEvent;
  exports.setup_ = setup_;
  exports.initAvo = initAvo;
}(typeof exports === 'undefined' ? this.Avo = {} : exports));

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["searchResult","courseSearchEvent"]
